import { Canvas, UIImage, UIText } from './canvas';
import App from '../main';
import { SDKManager } from './SDKManager';

export default class MenuScene extends Canvas {
    private objectiveButton: UIImage;
    private logo: UIImage;


    constructor() {
        super({ key: 'MenuScene' });
    }

    preload() {
        SDKManager.firstFrameReady();
        //console.log("FIRST FRAME READY");
        this.setupLoadingScreen();

        this.load.json('menuCanvas', 'ui/menu-canvas.json');
        this.load.multiatlas('game-ui', 'ui/game-ui.json', 'ui');
    }

    create() {
        super.setCanvas('menuCanvas');
        //console.log('Menu Scene Created');

        this.setupButtons();
        this.enableButtonsAndLogo();

        this.events.on("wake", this.onWake, this);
        this.events.on("sleep", this.onSleep, this);
    }

    private setupLoadingScreen() {
        let loadingScreen = document.getElementById('loading-screen');
        let item = document.getElementById('item');

        loadingScreen.classList.remove('hide');

        this.load.on('fileprogress', function (file) {
            item.innerText = "Loading";
        });

        this.load.on('complete', function () {
            loadingScreen.classList.add('hide');
        });
    }

    private setupButtons() {
        this.objectiveButton = this.children.getByName('Objective Button') as UIImage;
        this.logo = this.children.getByName('Logo') as UIImage;

        if (this.objectiveButton && this.logo) {
            this.objectiveButton.setInteractive().on('pointerdown', this.onObjectiveButtonClick, this);
        } else {
            console.error('Failed to find all required elements in the canvas');
        }
    }

    private isFirstTime:boolean = true;

    private enableButtonsAndLogo() {
        if (this.objectiveButton && this.logo) {
            this.objectiveButton.visible = true;
            this.logo.visible = true;
            if(this.isFirstTime){
                SDKManager.gameReady();
                this.isFirstTime = false;
                console.log("GAME READY");
            }
        }
    }

    private disableButtonsAndLogo() {
        if (this.objectiveButton && this.logo) {
            this.objectiveButton.visible = false;
            this.logo.visible = false;
        }
    }

    private onWake() {
        //console.log("MenuScene woken up");
        this.enableButtonsAndLogo();
    }

    private onSleep() {
        //console.log("MenuScene going to sleep");
        this.disableButtonsAndLogo();
    }

    private onEndlessButtonClick(): void {
        this.scene.sleep('MenuScene');
        if (this.scene.isSleeping('Game')) {
            //console.log("Waking Game");
            this.scene.wake('Game', { ObjectiveIndex: -1 });
        } else {
            //console.log("Launching Game");
            // this.scene.wake('InGameHUD');
            this.scene.launch('Game', { ObjectiveIndex: -1 });
        }
    }

    private onObjectiveButtonClick(): void {
        this.scene.sleep('MenuScene');
        if (this.scene.isActive('InGameHUD')) {
            this.scene.sleep('InGameHUD');
        }
        this.scene.run('Objective');
    }
}